// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type OwnerFragment = { __typename?: 'OwnerDTO', aggregateExtraFromPOSInDefaultProduct: boolean, allInclusiveDeduction: number | null, allInclusiveDeductionJunior: number | null, allInclusiveLunchDeduction: number | null, allInclusiveLunchDeductionJunior: number | null, allowUnassignedRoom: boolean, alwaysShowGroupDescriptionOnPlanner: boolean, autoCheckOutOnInvoice: boolean, blockFollowsRoomGroup: boolean, blockInvoiceProgressive: boolean, blockInvoicedService: boolean, blockPastService: boolean, blockSavedInvoice: boolean, breakfastDeduction: number | null, breakfastDeductionJunior: number | null, breakfastVATRate: number | null, buildIstatIgnoreDividedStays: boolean, channelManagerAvailability: boolean, channelManagerHotelCode: string | null, channelManagerNotifyMail: boolean, channelManagerNotifyProblemMail: boolean, channelManagerPassword: string | null, channelManagerPrice: boolean, channelManagerProvider: string | null, channelManagerReservation: boolean, channelManagerReservationUpdate: boolean, channelManagerRestriction: boolean, channelManagerUsername: string | null, channelMandatoryOnReservation: boolean, cityTaxDescriptionOnInvoice: string | null, cityTaxMandatoryFields: boolean, conciergeDays1: number | null, conciergeDays2: number | null, corpName: string, createProductOnCharge: boolean, createProductOnChargeByDescription: boolean, customerCode: string, dateFormat: string | null, dateFormatMedium: string | null, dateFormatShort: string | null, defaultFiscalPrinter: string | null, defaultFiscalTray: number | null, defaultInvoicePrinter: string | null, defaultInvoiceTray: number | null, defaultPaymentCityTaxId: number | null, defaultPrinter: string | null, defaultStartFbWithLunch: boolean, rackMessageMode: Types.RackMessageModeDto | null, defaultTray: number | null, defaultVATRate: number, depositHeaderOnInvoice: string | null, dinnerDeduction: number | null, dinnerDeductionJunior: number | null, dinnerVATRate: number | null, disableInvoiceTemporaryProgressive: boolean, disableModifyFromChannelIfOriginalStayChanged: boolean, divideBed: boolean, dividedBedsManagement: boolean, documentFolderOnReservation: boolean, editPriceOnPurchasedStayExtension: boolean, enabled: boolean, extraChargeOrderByDate: boolean, fixPriceOnReservationWizard: boolean, generateInvoiceAsDefault: boolean, genericRoomDescriptionOnInvoice: string | null, housekeeperNotesOnReservationWizard: boolean, id: number, includeImagesOnInvoice: boolean, invoiceExtraDisplayMode: Types.InvoiceExtraDisplayModeDto | null, invoiceRoomDisplayMode: Types.InvoiceRoomDisplayModeDto | null, lastISTATC59Progressive: number | null, lastPSProgressive: number | null, limitInvoiceProgressiveAndDate: boolean, lunchDeduction: number | null, lunchDeductionJunior: number | null, lunchVATRate: number | null, mail: string | null, mailAddressFrom: string | null, mailAlias: string | null, mailAuth: boolean, mailBcc: string | null, mailBccCM: string | null, mailCredentialsExternal: boolean, mailEncryptedPassword: string | null, mailOnZeroAvailability: boolean, mailUsername: string | null, masterBillOnFastExtra: boolean, multidbCurrencyId: number | null, multipleResevationOnGroupWizard: boolean, nf525: boolean, onlyFixedIndexOnPurchasedStay: boolean, otaMessaging: boolean, otaReporting: boolean, paymentMandatoryOnInvoice: boolean, popupOnSwitchRead: boolean, preselectRoomOnGroupWizard: boolean, psMandatoryDocumentDeadline: boolean, receiptDescriptionOnInvoice: string | null, reservationWithDepositStatusId: number | null, restaurantNotesOnReservationWizard: boolean, roomClientEnabled: boolean, roomNotReadyDays: number | null, roomNotReadyMode: number | null, segmentMandatoryOnReservation: boolean, showCityTaxOnBillPreview: boolean, showCouponOnFastExtra: boolean, showCustomersOnInvoice: boolean, showCustomersOnMasterInvoice: number | null, showDeletedReservationOnlyFromChannelManager: boolean, showDiscountOnInvoice: boolean, showIbanOnReceipts: boolean, showIdOnInvoice: boolean, showInOutOnMasterInvoice: boolean, showMultilanguageInvoice: boolean, showNotInvoicedDepositDescription: boolean, showPaymentOnReceipt: boolean, showPopupOnGenerateInvoice: boolean, showTreatmentOnInvoice: boolean, showTreatmentOnMasterInvoice: boolean, showVatOnReceipts: boolean, showZeroRoomOnExtraReceipt: boolean, smtpHost: string | null, smtpPort: string | null, startTls: boolean, stayOnGridsOrderBy: Types.StayOrderByDto | null, stayOrderOnGrids: number | null, switchExcludeNumbersFrom: string | null, switchExcludeNumbersTo: string | null, switchHost: string | null, switchModelId: number | null, switchPort: string | null, switchProductName: string | null, switchType: number | null, trackAddedBedPriceOnPurchasedStay: boolean, unassignedRoomFromWeb: boolean, useSubAccountOnExtraInsert: boolean, voucherNotes: number | null };

export const OwnerFragment = gql`
    fragment Owner on OwnerDTO {
  aggregateExtraFromPOSInDefaultProduct
  allInclusiveDeduction
  allInclusiveDeductionJunior
  allInclusiveLunchDeduction
  allInclusiveLunchDeductionJunior
  allowUnassignedRoom
  alwaysShowGroupDescriptionOnPlanner
  autoCheckOutOnInvoice
  blockFollowsRoomGroup
  blockInvoiceProgressive
  blockInvoicedService
  blockPastService
  blockSavedInvoice
  breakfastDeduction
  breakfastDeductionJunior
  breakfastVATRate
  buildIstatIgnoreDividedStays
  channelManagerAvailability
  channelManagerHotelCode
  channelManagerNotifyMail
  channelManagerNotifyProblemMail
  channelManagerPassword
  channelManagerPrice
  channelManagerProvider
  channelManagerReservation
  channelManagerReservationUpdate
  channelManagerRestriction
  channelManagerUsername
  channelMandatoryOnReservation
  cityTaxDescriptionOnInvoice
  cityTaxMandatoryFields
  conciergeDays1
  conciergeDays2
  corpName
  createProductOnCharge
  createProductOnChargeByDescription
  customerCode
  dateFormat
  dateFormatMedium
  dateFormatShort
  defaultFiscalPrinter
  defaultFiscalTray
  defaultInvoicePrinter
  defaultInvoiceTray
  defaultPaymentCityTaxId
  defaultPrinter
  defaultStartFbWithLunch
  rackMessageMode
  defaultTray
  defaultVATRate
  depositHeaderOnInvoice
  dinnerDeduction
  dinnerDeductionJunior
  dinnerVATRate
  disableInvoiceTemporaryProgressive
  disableModifyFromChannelIfOriginalStayChanged
  divideBed
  dividedBedsManagement
  documentFolderOnReservation
  editPriceOnPurchasedStayExtension
  enabled
  extraChargeOrderByDate
  fixPriceOnReservationWizard
  generateInvoiceAsDefault
  genericRoomDescriptionOnInvoice
  housekeeperNotesOnReservationWizard
  id
  includeImagesOnInvoice
  invoiceExtraDisplayMode
  invoiceRoomDisplayMode
  lastISTATC59Progressive
  lastPSProgressive
  limitInvoiceProgressiveAndDate
  lunchDeduction
  lunchDeductionJunior
  lunchVATRate
  mail
  mailAddressFrom
  mailAlias
  mailAuth
  mailBcc
  mailBccCM
  mailCredentialsExternal
  mailEncryptedPassword
  mailOnZeroAvailability
  mailUsername
  masterBillOnFastExtra
  multidbCurrencyId
  multipleResevationOnGroupWizard
  nf525
  onlyFixedIndexOnPurchasedStay
  otaMessaging
  otaReporting
  paymentMandatoryOnInvoice
  popupOnSwitchRead
  preselectRoomOnGroupWizard
  psMandatoryDocumentDeadline
  receiptDescriptionOnInvoice
  reservationWithDepositStatusId
  restaurantNotesOnReservationWizard
  roomClientEnabled
  roomNotReadyDays
  roomNotReadyMode
  segmentMandatoryOnReservation
  showCityTaxOnBillPreview
  showCouponOnFastExtra
  showCustomersOnInvoice
  showCustomersOnMasterInvoice
  showDeletedReservationOnlyFromChannelManager
  showDiscountOnInvoice
  showIbanOnReceipts
  showIdOnInvoice
  showInOutOnMasterInvoice
  showMultilanguageInvoice
  showNotInvoicedDepositDescription
  showPaymentOnReceipt
  showPopupOnGenerateInvoice
  showTreatmentOnInvoice
  showTreatmentOnMasterInvoice
  showVatOnReceipts
  showZeroRoomOnExtraReceipt
  smtpHost
  smtpPort
  startTls
  stayOnGridsOrderBy
  stayOrderOnGrids
  switchExcludeNumbersFrom
  switchExcludeNumbersTo
  switchHost
  switchModelId
  switchPort
  switchProductName
  switchType
  trackAddedBedPriceOnPurchasedStay
  unassignedRoomFromWeb
  useSubAccountOnExtraInsert
  voucherNotes
}
    `;
/* eslint-enable */